import { render, staticRenderFns } from "./web-analytics.vue?vue&type=template&id=afdbb92a&"
import script from "./web-analytics.vue?vue&type=script&lang=js&"
export * from "./web-analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports